// Utility to build an extended month list (past + future) merged with months that have data.
// Returns array of { month: "YYYY-MM", label: "Jan 2026", count: 12, hasData: true|false }.

const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function buildExtendedMonthList(availableMonths, pastMonths = 24, futureMonths = 12) {
  const dataMap = new Map();
  (availableMonths || []).forEach((m) => dataMap.set(m.month, m.count));

  const now = new Date();
  const list = [];
  for (let i = -pastMonths; i <= futureMonths; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
    const y = String(d.getFullYear());
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const key = `${y}-${mm}`;
    list.push({
      month: key,
      year: y,
      monthNum: mm,
      label: `${MONTH_NAMES[d.getMonth()]} ${y}`,
      count: dataMap.get(key) || 0,
      hasData: dataMap.has(key),
    });
  }

  // Ensure any availableMonths outside this range (older history) are still included
  (availableMonths || []).forEach((m) => {
    if (!list.find((x) => x.month === m.month)) {
      const [y, mm] = m.month.split('-');
      list.push({
        month: m.month,
        year: y,
        monthNum: mm,
        label: `${MONTH_NAMES[parseInt(mm, 10) - 1]} ${y}`,
        count: m.count,
        hasData: true,
      });
    }
  });

  list.sort((a, b) => b.month.localeCompare(a.month));
  return list;
}
